'use strict'

export class mainForm {
  constructor(formElement) {
    this.formElement = formElement
    this.initListeners()
  }

  get visibleFormFields() {
    if (!this.formElement) return []
    return this.formElement.querySelectorAll('[id][name]:not([hidden])')
  }

  get formSuccessElement() {
    if (!this.formElement) return false
    const wrapperElement = this.formElement.closest('main > section, main > div') ?? false
    if (!wrapperElement) return false
    return wrapperElement.querySelector('.form-success') || false
  }

  get formErrorsElement() {
    return this.formElement.querySelector('.form-errors') ?? false
  }

  get formErrorsListElement() {
    return this.formErrorsElement ? this.formErrorsElement.querySelector('.form-errors-list') : false
  }

  get fileUploadInputElement() {
    return this.formElement.querySelector('[name="uploads[]"][id="uploads"]') ?? false
  }

  get fileUploadControls() {
    if (!this.fileUploadInputElement && !this.fileUploadInputElement) return false
    return this.formElement.querySelector('.form-upload-controls') ?? false
  }

  get fileEmptyTextElement() {
    if (!this.fileUploadControls) return false
    return this.formElement.querySelector('.form-upload-file-empty-text') ?? false
  }

  get fileListElement() {
    if (!this.fileUploadControls) return false
    return this.formElement.querySelector('.form-upload-list') ?? false
  }

  get fileBadgeDeleteElement() {
    if (!this.fileListElement) return false
    return this.fileListElement.querySelector('.form-upload-list-delete') ?? false
  }

  set formStatus(formStatus) {
    if (!this.formElement) return
    this.formElement.setAttribute('status', formStatus)
  }

  handleFormErrorsMessages(show = false, errorMessages = []) {
    if (show) {

      this.formErrorsListElement.innerText = ''
      this.formErrorsElement.classList.remove('d-none')

      const fieldsWithErrors = Object.keys(errorMessages)

      fieldsWithErrors.forEach(errorField => {
        errorMessages[`${errorField}`].forEach(errorMessage => {
          const messageString = errorField === 'mainErrors' ? `Ein Konfigurationsfehler ist aufgetreten, bitte teilen Sie uns den folgendenden Fehler mit: ${errorMessage}` : `${errorMessage}`
          this.formErrorsListElement.innerHTML += `<li>${messageString}</li>`
        })
      })

    } else {

      this.formErrorsElement.classList.add('d-none')
      this.formErrorsListElement.innerText = ''

    }
  }

  handleSuccessBox(show = false) {
    if (!this.formSuccessElement) return false
    if (show) this.formSuccessElement.classList.remove('hidden')
    else this.formSuccessElement.classList.add('hidden')
  }

  handleUploadFieldList(uploadFiles = null) {
    if (!uploadFiles || uploadFiles.length === 0) {
      const formUploadListItems = this.fileListElement.querySelectorAll('span:not(.form-upload-list-delete)')
      formUploadListItems.forEach(formUploadListItem => formUploadListItem.remove())
      this.fileListElement.classList.add('d-none')
      this.handleFileEmptyTextElement(true)
    } else {

      this.fileListElement.querySelectorAll('.form-upload-list-item').forEach(item => item.remove())
      Array.from(uploadFiles).forEach(uploadFile => {


        const uploadFileName = uploadFile.name
        const uploadFileSize = (uploadFile.size / (1024 * 1024)).toFixed(1)
        this.fileListElement.insertAdjacentHTML("afterbegin", `<span class="form-upload-list-item"><span class="name">${uploadFileName}</span> <span class="size">${uploadFileSize} MB</span></span>`)
      })


      this.fileListElement.classList.remove('d-none')
      this.handleFileEmptyTextElement()
    }
  }

  handleFileEmptyTextElement(show = false) {
    if (show) this.fileEmptyTextElement.classList.remove('d-none')
    else this.fileEmptyTextElement.classList.add('d-none')
  }

  invalidateFormGroup(formGroup) {
    formGroup.classList.remove('valid')
    formGroup.classList.add('invalid')
  }

  validateFormGroup(formGroup) {
    formGroup.classList.remove('invalid')
    formGroup.classList.add('valid')
  }

  activateErrorText(textField, message) {
    textField.innerText = `${message}`
    textField.classList.remove('d-none')
    textField.classList.add('d-block')
  }

  deactivateErrorText(textField) {
    textField.innerText = ''
    textField.classList.add('d-none')
    textField.classList.remove('d-block')
  }

  invalidateField(field, messages) {
    const formGroup = field.closest('.form-group') || false
    const errorTextField = formGroup ? formGroup.querySelector('.error') : false
    const message = messages[0]

    if (formGroup) this.invalidateFormGroup(formGroup)
    if (errorTextField) this.activateErrorText(errorTextField, message)
  }

  validateField(field) {
    const formGroup = field.closest('.form-group') || false
    const errorTextField = formGroup ? formGroup.querySelector('.error') : false

    if (formGroup) this.validateFormGroup(formGroup)
    if (errorTextField) this.deactivateErrorText(errorTextField)
  }

  resetForm() {
    this.formStatus = ''
    this.handleFileEmptyTextElement(true)

    this.handleUploadFieldList()
    this.fileUploadInputElement.value = ''

    Array.from(this.visibleFormFields).forEach(formField => {
      const formGroup = formField.closest('.form-group') || false
      const errorTextField = formGroup ? formGroup.querySelector('.error') : false

      formField.value = ''

      if (formGroup) {
        formGroup.classList.remove('invalid')
        formGroup.classList.remove('valid')
      }

      if (errorTextField) {
        errorTextField.innerText = ''
        errorTextField.classList.remove('d-block')
        errorTextField.classList.add('d-none')
      }
    })
  }

  successBoxListener() {
    if (!this.formSuccessElement) return false

    const hideButton = this.formSuccessElement.querySelector('.form-success-hide') || false
    if (!hideButton) return false

    hideButton.addEventListener('click', event => {
      event.preventDefault()
      this.handleSuccessBox()
    })

  }

  uploadListener() {
    if (!this.fileUploadControls || !this.fileUploadInputElement || !this.fileBadgeDeleteElement) return false

    this.fileUploadInputElement.addEventListener('change', () => {
      const uploadFiles = this.fileUploadInputElement.files ?? false
      if (!uploadFiles) return false

      this.handleUploadFieldList(uploadFiles)
    })
    this.fileBadgeDeleteElement.addEventListener('click', event => {
      event.preventDefault()

      this.fileUploadInputElement.value = ''
      this.handleUploadFieldList()
      this.handleFileEmptyTextElement(true)
    })
  }

  submitListener() {
    this.formElement.addEventListener('submit', event => {
      event.preventDefault()

      const XML_REQUEST = new XMLHttpRequest()
      XML_REQUEST.open(event.target.method, event.target.action)
      XML_REQUEST.setRequestHeader('X-Requested-With', 'form')
      XML_REQUEST.onload = progressEvent => {
        const errorMessages = JSON.parse(progressEvent.target.response)
        if (progressEvent.target.status === 200) {
          this.formStatus = 'loading'
          Array.from(this.visibleFormFields).forEach(formField => this.validateField(formField))
          this.handleFormErrorsMessages()

          setTimeout(() => {
            this.formStatus = ''
            this.handleSuccessBox(true)
            this.resetForm()
          }, 2000)

        } else if (progressEvent.target.status === 404) {
          this.handleFormErrorsMessages(true, errorMessages)

        } else {

          this.formStatus = ''
          const fieldsWithErrors = Object.keys(errorMessages)

          const invalidFields = Array.from(this.visibleFormFields).filter((item) => fieldsWithErrors.includes(item.name))
          const validFields = Array.from(this.visibleFormFields).filter((item) => !fieldsWithErrors.includes(item.name))

          invalidFields.forEach(formField => this.invalidateField(formField, errorMessages[`${formField.name}`]))
          validFields.forEach(formField => this.validateField(formField))
          this.handleFormErrorsMessages(true, errorMessages)

          const firstInvalidField = invalidFields[0]
          if (!firstInvalidField) return false

          const scrollSelector = invalidFields[0].closest('.offcanvas') ?
            invalidFields[0].closest('.offcanvas').querySelector('.offcanvas-body') :
            window

          invalidFields[0].focus()
          scrollSelector.scrollBy({
            top: invalidFields[0].getBoundingClientRect().top - 200,
            left: 0,
            behavior: 'smooth'
          })
        }
      }

      XML_REQUEST.send(new FormData(event.target))

    })
  }

  initListeners() {
    if (!this.formElement) return false
    this.uploadListener()
    this.submitListener()
    this.successBoxListener()
  }
}
